import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListOrdersComponent } from './components/list-orders/list-orders.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrdersFilterComponent } from './components/orders-filter/orders-filter.component';
import { ReviewReasonPipe } from 'src/app/core/pipes/review-reason.pipe';



@NgModule({
  declarations: [
    ListOrdersComponent,
    OrdersFilterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReviewReasonPipe,
  ]
})
export class OrdersModule { }